<div class="floating-player" 
     [class.visible]="shouldShow"
     [class.has-track]="hasTrack">

  <div *ngIf="hasTrack" class="player-content">
    
    <!-- Album Artwork -->
    <div class="album-art" (click)="expandPlayer()">
      <img *ngIf="getAlbumImage(); else noArtwork" 
           [src]="getAlbumImage()" 
           [alt]="currentTrack?.album?.name"
           class="album-image">
      <ng-template #noArtwork>
        <mat-icon class="no-artwork-icon">music_note</mat-icon>
      </ng-template>
      
      <!-- Playing Indicator -->
      <div class="playing-indicator" [class.active]="isPlaying">
        <mat-icon>{{ isPlaying ? 'graphic_eq' : 'pause' }}</mat-icon>
      </div>
    </div>

    <!-- Track Info -->
    <div class="track-info" (click)="expandPlayer()">
      <div class="track-name" [title]="currentTrack?.name">
        {{ currentTrack?.name }}
      </div>
      <div class="artist-name" [title]="getArtistNames()">
        {{ getArtistNames() }}
      </div>
    </div>

    <!-- Time Display -->
    <div class="time-section">
      <div class="time-display">
        <span class="current-time">{{ getCurrentTimeFormatted() }}</span>
        <span class="time-separator">/</span>
        <span class="total-time">{{ getTotalTimeFormatted() }}</span>
      </div>
    </div>

    <!-- Control Buttons -->
    <div class="controls-section">
      <button mat-icon-button 
              matTooltip="Previous track"
              (click)="previousTrack()"
              class="control-button prev-button">
        <mat-icon>skip_previous</mat-icon>
      </button>

      <button mat-icon-button 
              [class.playing]="isPlaying"
              matTooltip="{{ isPlaying ? 'Pause' : 'Play' }}"
              (click)="togglePlay()"
              class="play-button">
        <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
      </button>

      <button mat-icon-button 
              matTooltip="Next track"
              (click)="nextTrack()"
              class="control-button">
        <mat-icon class="skip-next-icon">skip_next</mat-icon>
      </button>

      <button mat-icon-button 
              matTooltip="Cast to device"
              (click)="openDeviceSelector()"
              class="cast-button"
              [class.active]="hasOtherDevices">
        <mat-icon>cast</mat-icon>
      </button>
    </div>

    <!-- Expand Button -->
    <div class="expand-section">
      <button mat-icon-button 
              matTooltip="Open expanded player"
              (click)="expandPlayer()"
              class="expand-button">
        <mat-icon>open_in_full</mat-icon>
      </button>
    </div>
  </div>
</div>